module.exports = __webpack_public_path__ + "img/s2-4-ja.7933bef1.jpg";